import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { TeamMember } from 'src/app/pages/about/team/pageContext';
import { useTeamPageData } from 'src/app/pages/about/team/pageContext';

export type Group = {
	name: string;
	items: readonly TeamMember[];
	clientRenderOnly?: boolean;
};

type Result = ModelHookResult<{
	groups: readonly Group[];
}>;

export function useTeamMembers(): Result {
	const {
		data: { staff },
	} = useTeamPageData();
	const { translate } = useI18n();

	return {
		data: {
			groups: useMemo(() => {
				return [
					{
						name: translate('fe.pages.team.leadership_team_title'),
						items: staff.filter(({ leader }) => leader),
					},
					{
						name: translate('fe.pages.team.founding_team_title'),
						items: staff.filter(({ founder }) => founder),
					},
					{
						name: translate('fe.pages.team.title'),
						items: staff.filter(({ founder, leader }) => !founder && !leader),
						clientRenderOnly: true,
					},
				].filter(({ items }) => !!items.length);
			}, [staff, translate]),
		},
	};
}
